<div class="footer">
    <div class="card clearfix">
        <div class="logoDiv">
            {{setLabel("poweredByLabel")}} &nbsp; <a href="http://tecfolk.com/" target="_blank"><img src="assets/layout/images/tecfolk-logo-trasprantNormal.png" alt=""></a> <br>
            {{setLabel("phone:Label")}} {{mobileNumber}}. {{setLabel("email:Label")}} {{emailAddress}}.
        </div>
        <div class="url">
            <span>
                <i class="fa fa-globe" aria-hidden="true"></i>
            </span>
            <a href="http://tecfolk.com/tecgym.html"
                style="color: #3d698a;margin-left: 5px; font-size: 14px;text-decoration: underline;" target="_blank">{{setLabel("knowAboutTecGymLabel")}}</a>
        </div>
    </div>
</div>